<div class="modal-header px-4 d-flex">
  <h3 class="dialog-title text-center">{{ 'Add result' | translate }}</h3>
  <i class="fa fa-times p-2 cursor-pointer" (click)="close()"></i>
</div>
<div mat-dialog-content>
  <div class="modal-content">
    @for (group of groupedRisks; track trackByIndex($index)) {
      <div class="px-4">
        <div class="custom-theme-table">
          <div class="table-responsive outer-bordered-table">
            <table mat-table class="table" [dataSource]="group.results">
              <ng-container matColumnDef="agentId">
                <th mat-header-cell *matHeaderCellDef>{{ 'Agent' | translate }}</th>
                <td mat-cell *matCellDef="let element" class="hover-none">{{ element.agentName }}
                </td>
              </ng-container>
              <ng-container matColumnDef="jurisdictionId">
                <th mat-header-cell *matHeaderCellDef>{{ 'Jurisdiction' | translate }}</th>
                <td mat-cell *matCellDef="let element" class="hover-none">{{ element.jurisdictionName }}
                </td>
              </ng-container>
              <ng-container matColumnDef="oelTypeId">
                <th mat-header-cell *matHeaderCellDef>{{ 'OEL' | translate }}</th>
                <td mat-cell *matCellDef="let element" class="hover-none">{{ element.oelTypeName }}</td>
              </ng-container>
              <ng-container matColumnDef="sampleCensor">
                <th mat-header-cell *matHeaderCellDef></th>
                <ng-container mat-cell *matCellDef="let row; let i = index">
                  @if (i === 0) {
                    <td [attr.rowspan]="i === 0 ? displayedColumns.length : null">
                      @if (!group.isTwa) {
                        <mat-form-field appearance="fill"
                          class="d-flex justify-content-center small-field">
                          <mat-select class="text-center" [(ngModel)]="group.sampleCensor">
                            @for (sensor of sensorList; track trackById($index, sensor)) {
                              <mat-option [value]="sensor.id">
                                {{ sensor.name }}
                              </mat-option>
                            }
                          </mat-select>
                        </mat-form-field>
                      }
                    </td>
                  }
                </ng-container>
              </ng-container>
              <ng-container matColumnDef="totalMass">
                <th mat-header-cell *matHeaderCellDef>{{ 'Total Mass' | translate }}</th>
                <ng-container mat-cell *matCellDef="let row; let i = index">
                  @if (i === 0) {
                    <td [attr.rowspan]="i === 0 ? displayedColumns.length : null">
                      @if (!group.isTwa) {
                        @if (data.sampleType === sampleTypeEnum.Wipe) {
                          <div class="d-flex align-items-center justify-content-center">
                            <mat-form-field appearance="fill" >
                              <input matInput type="number" [(ngModel)]="group.totalMass" />
                            </mat-form-field>
                            <mat-form-field appearance="fill" class="small-field">
                              <mat-select class="text-center" [(ngModel)]="group.massUnit">
                                @for (unit of unitList; track trackById($index, unit)) {
                                  <mat-option [value]="unit.id">
                                    {{ unit.name }}
                                  </mat-option>
                                }
                              </mat-select>
                            </mat-form-field>
                          </div>
                        } @else {
                          <div class="d-flex align-items-center justify-content-center">
                            <mat-form-field appearance="fill" >
                              <input matInput type="number" [(ngModel)]="group.totalMass"
                                [disabled]="!!group.concentration" />
                              </mat-form-field>
                              <mat-form-field appearance="fill" class="small-field">
                                <mat-select class="text-center" [(ngModel)]="group.massUnit">
                                  @for (unit of unitList; track trackById($index, unit)) {
                                    <mat-option [value]="unit.id">
                                      {{ unit.name }}
                                    </mat-option>
                                  }
                                </mat-select>
                              </mat-form-field>
                            </div>
                          }
                        } @else {
                          <div class="text-center">
                            {{ group.totalMass != null ? (group.sampleCensorSign || '') + ' ' + (group.totalMass | number:'1.0-4') + ' ' + (massUnits[group.massUnit] || 'µg') : '-' }}
                          </div>
                        }
                      </td>
                    }
                  </ng-container>
                </ng-container>
                <ng-container matColumnDef="blankCorrectedMass">
                  <th mat-header-cell *matHeaderCellDef>{{ 'Blank Corrected Mass' | translate }}</th>
                  <ng-container mat-cell *matCellDef="let row; let i = index">
                    @if (i === 0) {
                      <td [attr.rowspan]="i === 0 ? displayedColumns.length : null">
                        <div class="text-center">
                          {{ group.blankCorrectedMass != null ? (group.blankCorrectedMass | number:'1.0-4') + ' ' + (massUnits[group.massUnit] || 'µg') : '-' }}
                        </div>
                      </td>
                    }
                  </ng-container>
                </ng-container>
                <ng-container matColumnDef="concValue">
                  <th mat-header-cell *matHeaderCellDef></th>
                  <ng-container mat-cell *matCellDef="let row; let i = index">
                    @if (i === 0) {
                      <td [attr.rowspan]="i === 0 ? displayedColumns.length : null">
                        @if (!group.isTwa) {
                          <mat-form-field appearance="fill"
                            class="d-flex justify-content-center small-field">
                            <mat-select class="text-center" [(ngModel)]="group.sampleCensor">
                              @for (sensor of sensorList; track trackById($index, sensor)) {
                                <mat-option [value]="sensor.id">
                                  {{ sensor.name }}
                                </mat-option>
                              }
                            </mat-select>
                          </mat-form-field>
                        }
                      </td>
                    }
                  </ng-container>
                </ng-container>
                <ng-container matColumnDef="concentration">
                  <th mat-header-cell *matHeaderCellDef>{{ 'Total Concentration' | translate }}
                  {{!group.isTwa && group.unitSymbol ? '(' + group.unitSymbol+')' : ''}}</th>
                  <ng-container mat-cell *matCellDef="let row; let i = index">
                    @if (i === 0) {
                      <td [attr.rowspan]="i === 0 ? displayedColumns.length : null">
                        @if (!group.isTwa) {
                          <mat-form-field appearance="fill" class="d-flex justify-content-center">
                            <input matInput type="number" [(ngModel)]="group.concentration"
                              [disabled]="group.totalMass && !group.concentration" />
                            </mat-form-field>
                          } @else {
                            <div class="text-center">
                              {{ group.concentration ? (group.sampleCensorSign || '') + ' ' + (group.concentration | number:'1.0-4') + ' ' +
                              group.unitSymbol : '-' }}
                            </div>
                          }
                        </td>
                      }
                    </ng-container>
                  </ng-container>
                  <ng-container matColumnDef="unsampledTimeConcValue">
                    <th mat-header-cell *matHeaderCellDef>{{ 'Unsampled Concentration' | translate }}
                      {{!group.isTwa && group.unitSymbol ? '(' + group.unitSymbol+')' : ''}}
                    </th>
                    <ng-container mat-cell *matCellDef="let row; let i = index">
                      @if (i === 0) {
                        <td [attr.rowspan]="i === 0 ? displayedColumns.length : null">
                          @if (!group.isTwa && row.unsampledTimeConcValue !== unsampledTimeCorrectionTypeEnum.AssumeZero
                            && row.unsampledTimeConcValue !== unsampledTimeCorrectionTypeEnum.AssumeUniform) {
                            <mat-form-field appearance="fill">
                              <input matInput type="number" [(ngModel)]="group.unsampledConcentration" />
                            </mat-form-field>
                          } @else {
                            <div class="text-center">{{
                              row.unsampledTimeConcValue === unsampledTimeCorrectionTypeEnum.AssumeZero
                              ? 0: row.unsampledTimeConcValue ===
                              unsampledTimeCorrectionTypeEnum.AssumeUniform? ('Same as Sample' | translate):
                            (group.unsampledConcentration | number:'1.0-4') || '-' }}</div>
                          }
                        </td>
                      }
                    </ng-container>
                  </ng-container>
                  <ng-container matColumnDef="twaResult">
                    <th mat-header-cell *matHeaderCellDef>{{ (data.sampleType === sampleTypeEnum.Biological ? 'Result' : 'TWA Result') | translate }}
                      {{ data.sampleType === sampleTypeEnum.Wipe ? '(' + getTwaUnitSymbol(group) + ')' : (!group.isTwa && group.unitSymbol ? '(' + group.unitSymbol + ')' : '') }}
                    </th>
                    <ng-container mat-cell *matCellDef="let row; let i = index">
                      @if (i === 0) {
                        <td [attr.rowspan]="i === 0 ? displayedColumns.length : null">
                          @if (!group.isTwa) {
                            <div class="d-flex justify-content-center">
                              <button class="custom-main-btn bordered-btn" (click)="computeTWA(group)">
                                {{ getTwaButtonLabel() | translate }}
                              </button>
                            </div>
                          } @else {
                            <div class="text-center">
                              {{ group.twa != null? (group.sampleCensorSign || '') + ' ' + (group.twa | number:'1.0-4') + ' ' +
                              (data.sampleType === sampleTypeEnum.Wipe ? getTwaUnitSymbol(group) : group.unitSymbol) : '-' }}
                            </div>
                          }
                        </td>
                      }
                    </ng-container>
                  </ng-container>
                  <ng-container matColumnDef="dosePercentage">
                    <th mat-header-cell *matHeaderCellDef>{{ "Dose %" | translate }}</th>
                    <ng-container mat-cell *matCellDef="let row; let i = index">
                      <td>
                        @if (!group.isTwa) {
                          <mat-form-field appearance="fill">
                            <input matInput type="number" [(ngModel)]="row.dosePercentage" />
                          </mat-form-field>
                        } @else {
                          <div class="text-center">
                            {{(row.dosePercentage | number:'1.0-4') || '-' }}%
                          </div>
                        }
                      </td>
                    </ng-container>
                  </ng-container>
                  <ng-container matColumnDef="twa">
                    <th mat-header-cell *matHeaderCellDef>{{ "TWA" | translate }} @if (!group.isTwa && group.unitSymbol) {
                      <span
                      >({{group.unitSymbol}})</span>
                    }</th>
                    <ng-container mat-cell *matCellDef="let row; let i = index">
                      <td>
                        <div class="text-center">
                          {{ row.twa ? (row.twa | number:'1.0-4') + ' ' +
                          group.unitSymbol : '-' }}
                        </div>
                      </td>
                    </ng-container>
                  </ng-container>
                  <ng-container matColumnDef="edit">
                    <th mat-header-cell *matHeaderCellDef></th>
                    <ng-container mat-cell *matCellDef="let row; let i = index">
                      @if(data.sampleType === sampleTypeEnum.Noise){
                        <td>
                          @if (!group?.isTwa) {
                            <div class="d-flex justify-content-center">
                              <button class="custom-main-btn bordered-btn" (click)="computeTWA(group, row)">
                              {{ "Update Result" | translate }}</button>
                            </div>
                          } @else {
                            <mat-icon class="medium-icon cursor-pointer"
                            (click)="allowUpdate(group)">edit</mat-icon>
                          }
                        </td>
                        }@else if(data.sampleType === sampleTypeEnum.Wipe){
                        @if (i === 0) {
                          <td [attr.rowspan]="i === 0 ? displayedColumns.length : null">
                            @if (group.isTwa) {
                              <mat-icon class="medium-icon cursor-pointer"
                              (click)="allowUpdate(group)">edit</mat-icon>
                            }
                          </td>
                        }
                      }
                      @else {
                      @if (i === 0) {
                        <td [attr.rowspan]="i === 0 ? displayedColumns.length : null">
                          @if (group.isTwa) {
                            <mat-icon class="medium-icon cursor-pointer"
                            (click)="allowUpdate(group)">edit</mat-icon>
                          }
                        </td>
                      }
                    }
                  </ng-container>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
              </table>
            </div>
          </div>
        </div>
      }
    </div>
  </div>